import Vuex from 'vuex';
import Vue from 'vue';
import {
    getCtaText,
    getCtaLink,
    getDetailsLink,
    getDetailsText,
    getUserInput,
    getUserInputByKey,
    getUpdateCount,
    getTermsRange,
    getAmountRange,
} from '@app/store/shared/getters';

import { setUpdateCount, setTotal, setRate, setData, setAmount } from '@app/store/shared/actions';

import {
    setDataMutation,
    setTotalMutation,
    setRateMutation,
    setUpdateCountMutation,
    setSecondYearTotalMutation,
    setSecondYearRateMutation,
} from '@app/store/shared/mutations';

const loan = (data) => ({
    state: {
        hidden: [],
        ...data,
        total: 0,
        secondYearTotal: 0,
        rate: 0,
        secondYearRate: 0,
        updateCount: 0,
        currencySymbol: '₽',
        currencyShortTitle: 'рубли',
        category: 'walk_in',
    },
    getters: {
        getCtaText,
        getCtaLink,
        getDetailsLink,
        getDetailsText,
        getUserInput,
        getUserInputByKey,
        getUpdateCount,
        getTermsRange,
        getAmountRange,
        getCurrencySymbol(state) {
            return state.currencySymbol;
        },
        getCurrencyMeasureUnitTitle(state) {
            return state.currencyShortTitle;
        },
        getDataByKey(state, getters) {
            return (key) => state.data[getters.getSelectedCategory][key];
        },
        getSelectedCategory(state, getters) {
            return getters.getUserInputByKey('category');
        },
        getTotal(state) {
            return state.total;
        },
        getSecondYearTotal(state) {
            return state.secondYearTotal;
        },
        getRate(state) {
            return state.rate;
        },
        getSecondYearRate(state) {
            return state.secondYearRate;
        },
        getInsuranceToggle(state) {
            return state.insuranceToggle;
        },
        getHiddenBlocks(state) {
            return state.hidden;
        },
    },
    actions: {
        setTerm({ dispatch }, payload) {
            //changing the term changes the numberOfPayments. 1 month have 1 payment
            dispatch('setNumberOfPayments', payload);

            return dispatch('setData', payload);
        },
        setNumberOfPayments({ dispatch }, payload) {
            return dispatch('setData', { key: 'numberOfPayments', val: payload.val });
        },
        setSecondYearRate({ commit }, payload) {
            commit('setSecondYearRate', payload);
        },
        setSecondYearTotal({ commit }, payload) {
            commit('setSecondYearTotal', payload);
        },
        setUpdateCount,
        setTotal,
        setRate,
        setData,
        setAmount,
    },
    mutations: {
        setNumberOfPayments(state, payload) {
            state.numberOfPayments = payload;
        },
        setSecondYearRate(state, payload) {
            state.secondYearRate = payload;
        },
        setSecondYearTotal(state, payload) {
            state.secondYearTotal = payload;
        },
        setDataMutation,
        setTotalMutation,
        setRateMutation,
        setSecondYearTotalMutation,
        setSecondYearRateMutation,
        setUpdateCountMutation,
    },
});

Vue.use(Vuex);

const createStore = ({ data }) => {
    return new Vuex.Store({
        modules: {
            loan: loan(data),
        },
    });
};

export default createStore;
